/* eslint-disable ember/no-computed-properties-in-native-classes, no-restricted-properties, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class CometController extends Controller {
  // Services
  @service
  session;

  @service
  store;

  @service
  toaster;

  @alias('model.goal')
  goal;

  @alias('model.goalPlan')
  goalPlan;

  @tracked
  generating = false;
  @tracked
  loadingMsg = null;
  @tracked
  errorMsg = null;
  @tracked
  deleteDialogOpen = false;
  @tracked
  planToDelete = null;

  @action
  createGoalPlan() {
    let messages = [
      'Scanning the cosmos...',
      'Making magic happen, hold tight!',
      'Prepare for liftoff!',
    ];
    this.loadingMsg = messages[(messages.length * Math.random()) | 0];
    this.generating = true;
    const goalPlan = {
      jurisdiction: this.session.get('school.jurisdiction'),
      academicLevel: this.goal.get('category.label'),
      subject: this.goal.get('subject.label'),
      goal: this.goal.get('educatorDescription'),
      // Note: this field is removed in favour of hashing the generated prompt.
      goalId: this.goal.id,
    };
    const record = this.store.createRecord('coach/goal-plan', goalPlan);
    record
      .save()
      .then(() => {
        return this.goalPlan.update();
      })
      .then(() => {
        this.generating = false;
      })
      .catch(() => {
        this.generating = false;
        this.errorMsg =
          'There was an error generating your goal plan. Your goal may be inappropriate. Please try again or modify your goal.';
      });
  }

  @action
  deleteGoalPlan() {
    this.planToDelete
      .destroyRecord()
      .then(() => {
        this.toaster.success('Goal plan has been deleted!');
      })
      .catch(() => {
        this.toaster.error('Error deleting Goal Plan');
      })
      .finally(() => {
        this.deleteDialogOpen = false;
      });
  }

  @action
  openDeleteDialog(plan) {
    this.planToDelete = plan;
    this.deleteDialogOpen = true;
  }

  @action
  rateGoalActivity(plan, suggestion, score) {
    const activities = plan.activities;
    const activity = findBy(activities, 'title', suggestion.title);
    const ratings = activity.ratings;
    let rating = findBy(ratings, 'personId', this.session.person.id);
    // determine whether a rating should be created, updated or deleted
    if (rating === undefined) {
      // create rating as there is no previous rating
      ratings.createFragment({
        personId: this.session.person.id,
        rating: score,
      });
      activity.set('ratingSum', activity.ratingSum + score);
    } else {
      // remove existing rating from sum
      activity.set('ratingSum', activity.ratingSum - rating.rating);
      if (rating.rating === score) {
        // delete existing rating
        ratings.removeObject(rating);
      } else {
        // update existing rating
        rating.set('rating', score);
        activity.set('ratingSum', activity.ratingSum + score);
      }
    }
    activity.set('ratingCount', activity.ratings.get('length'));
    plan.save();
  }

  @action
  closeErrorDialog() {
    this.errorMsg = null;
  }
}
